import { InjectionToken } from '@angular/core';
import { I18nDescLoader } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const I18N_DESC_LOADER: InjectionToken<I18nDescLoader<Record<string, string>>> = new InjectionToken<
  I18nDescLoader<Record<string, string>>
>('i18nDescLoader', {
  factory: () => () => Promise.resolve({})
});
